import React, { createContext } from 'react';

// Create a ChatContext
// It will provide the chat state and functions to its consumers.
export const ChatContext = createContext(undefined);